// Create: /pages/AdminFeePage.jsx
import React from 'react';
import AdminFees from '../components/Admin/AdminFees';

const AdminFeesPage = () => {
  return <AdminFees />;
};

export default AdminFeesPage;